<template>
    <v-dialog
        v-model="addBillingCodeDialog"
        persistent
        width="500"
    >
        <template v-slot:activator="{ attrs }">
            <v-btn
                v-if="modelType === 'Add'"
                depressed
                outlined
                v-bind="attrs"
                @click="openDialog"
            >
                <v-icon
                    left
                    class="action-icon"
                >
                    mdi-plus
                </v-icon>
                Add Billing Code
            </v-btn>
            <v-icon
                v-if="modelType === 'Edit'"
                v-bind="attrs"
                @click="openDialog"
            >
                mdi-pencil
            </v-icon>
        </template>
        <v-card id="add_member_code_dialog">
            <v-card-title class="text-h5 lighten-2">
                <span v-if="modelType === 'Add'">Add Billing Code</span>
                <span v-if="modelType === 'Edit'">Edit Billing Code</span>
            </v-card-title>
            <v-divider />
            <v-card-text>
                <v-form
                    ref="form"
                    v-model="formValid"
                >
                    <v-row class="mt-5">
                        <v-col
                            v-if="addBillingCodeDialog"
                            cols="12"
                            sm="12"
                            class="py-0"
                        >
                            <v-select
                                v-model="code"
                                label="Billing Code"
                                :items="
                                    companyBillingCodes.map((item) => item.code.toUpperCase())
                                "
                                outlined
                                dense
                                class="upper-case"
                                :rules="billingCodeRules"
                                @change="onCodeChange"
                            />
                        </v-col>
                        <v-col
                            v-if="addBillingCodeDialog"
                            cols="12"
                            md="12"
                            class="py-0"
                        >
                            <v-text-field
                                v-model="quantity"
                                label="Quantity"
                                outlined
                                dense
                                type="number"
                                required
                                :rules="quantityRules"
                            />
                        </v-col>
                        <v-col
                            v-if="addBillingCodeDialog"
                            cols="12"
                            md="12"
                            class="py-0"
                        >
                            <v-text-field
                                v-if="showBillingAmount"
                                v-model="amount"
                                label="Amount"
                                outlined
                                dense
                                class="upper-case"
                                required
                                :rules="amountRules"
                                @input="formatCurrency($event.target.value)"
                            />
                        </v-col>
                        
                        <v-col
                            v-if="addBillingCodeDialog"
                            cols="12"
                            md="12"
                            class="py-0"
                        >
                            <v-select
                                v-model="minutes"
                                :items="billingCodeTimeWorked"
                                item-text="label"
                                item-value="value"
                                label="Time Worked"
                                outlined
                                dense
                                class="upper-case"
                                :rules="minutesRules"
                            />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                    style="text-transform: none !important"
                    outlined
                    @click="closedDialog"
                >
                    Cancel
                </v-btn>
                <v-btn
                    style="text-transform: none !important"
                    depressed
                    color="primary"
                    :disabled="!addBillingCodeDialog || !code || !minutes"
                    @click="save"
                >
                    <span v-if="modelType === 'Add'">Add</span>
                    <span v-if="modelType === 'Edit'">Update</span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';
import CompanyBillingMixin from '@/mixins/CompanyBillingMixin';
import {formatCurrency} from '@/utils/formatCurrency.js'; 
export default {
    mixins: [CompanyBillingMixin],
    props: {
        modelType: {
            type: String,
            default: '',
        },
        responseData: {
            type: [Object],
            default: () => {},
            required: true,
        },
    },
    data() {
        const {
            TR_rowid,
            rowid = '',
            code = '',
            amount = '',
            minutes = '',
            quantity = '',
        } = this.responseData;
        return {
            TR_rowid,
            rowid,
            code,
            amount,
            quantity,
            minutes,
            formValid: false,
            addBillingCodeDialog: false,
        };
    },
    methods: {
        openDialog() {
            this.addBillingCodeDialog = true;
            // this.resetFormData();
        },
        closedDialog() {
            this.addBillingCodeDialog = false;
        },
        resetFormData() {
            this.code = '';
            this.quantity = '';
            this.amount = '';
            this.minutes = '';
            this.formValid = false;           
        },
        capitalized(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        async save() {
            let response = {};
            let defaultAmount = await this.getBillingAmount(this.code);
            defaultAmount = defaultAmount ? defaultAmount : 0;           
            this.$refs.form.validate();
            if (!this.showBillingAmount)
                this.amount = defaultAmount;
            if (this.formValid && this.modelType === 'Add') {
                let data = {
                    TR_rowid: this.TR_rowid,
                    quantity: this.quantity,
                    code: this.code,
                    minutes: this.minutes,
                    amount: this.amount ? this.amount : defaultAmount,
                };                
                response = await webtmsBackend.addResponseBilling(data);
            } else if (this.formValid && this.modelType === 'Edit') {
                if (!this.showBillingAmount)
                    this.amount = defaultAmount;
                let data = {
                    TRB_rowid: this.rowid,
                    quantity:this.quantity,
                    code: this.code,
                    minutes: this.minutes,
                    amount: this.amount ? this.amount : defaultAmount,
                };
                response = await webtmsBackend.updateResponseBilling(data);
            }
            if (response.result.result === 'ERR') {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: response.result.message,
                });
            } else if (response.result.result === 'OK') {
                this.$store.dispatch('setSnackbar', {
                    text: response.result.message,
                    color: 'success',
                });
                this.$store.dispatch(
                    'updateTicketResponsesBilling',
                    response.Ticket_ResponsesBilling
                );
            }
            this.addBillingCodeDialog = false;
        },
        async getBillingAmount(code) {
            let billingCode = await this.companyBillingCodes.find(
                (item) => item.code.toUpperCase() === code.toUpperCase()
            );
            let billingAmount = billingCode ? billingCode.amount : 0;
            return billingAmount;
        },
        async onCodeChange() {
            let billingAmount = await this.getBillingAmount(this.code);
            if (billingAmount){
                this.amount = billingAmount;     
            }else{
                this.amount = 0;
            }

        },
        formatCurrency(value) {
            return formatCurrency(value);
        },
    },
};
</script>
<style></style>
